import { render, staticRenderFns } from "./NewsListItems.vue?vue&type=template&id=59f5d9a2&scoped=true"
import script from "./NewsListItems.vue?vue&type=script&lang=js"
export * from "./NewsListItems.vue?vue&type=script&lang=js"
import style0 from "./NewsListItems.vue?vue&type=style&index=0&id=59f5d9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f5d9a2",
  null
  
)

export default component.exports